import { Divider, Image } from "antd";
import { Trans, useTranslation } from "react-i18next";
import LogoFooter from "../../../assets/images/footer/footer_logo.png";
import { useLayout } from "../../../context/LayoutContext";
import styles from "./styles.module.scss";

const FooterComponent = () => {
  const { getPadding } = useLayout();
  const { t } = useTranslation();

  return (
    <div
      className={styles.footerContainer}
      style={{ paddingLeft: getPadding(), paddingRight: getPadding() }}
    >
      <div className={styles.footerColumn}>
        <div className={styles.colLeft}>
          <Image
            className={styles.logoImage}
            src={LogoFooter}
            preview={false}
          />
          <text className={styles.desc}>{t("footer.desc")}</text>
        </div>
        <div className={styles.colRight}>
          <text className={styles.infoTitle}>{t("footer.company.info")}</text>
          <text className={styles.infoContent}>
            <Trans i18nKey="footer.service" />
          </text>
        </div>
      </div>
      <Divider />
      <div className={styles.footerColumn}>
        <div className={styles.colLeft}>
          <text className={styles.copyright}>{t("footer.company")}</text>
        </div>
        <div className={styles.colRight}>
          <text className={styles.copyright}>{t("footer.copyright")}</text>
        </div>
      </div>
    </div>
  );
};

export default FooterComponent;
